import _ from "lodash";
import { createSelector } from "reselect";

const insights = state => state.insights;

// This is extremely ugly and should be
// re-written asap!
export const extractTagsFromInsights = createSelector([insights], insights => {
  return _.uniq(
    _.toArray(
      _.mapValues(
        _.filter(insights, (
          value => typeof value.tag === "string": value.tag)),
        "tag"
      )
    )
  );
});

export const extractTopicsFromInsights = createSelector([insights], insights => {
  const topics = _.map(_.uniq(_.flattenDeep(Object.keys(insights).map(key => insights[key].topics ? insights[key].topics.split(',') : []))), _.trim)

  return _.sortBy(_.uniq(topics));
})



// WEBPACK FOOTER //
// ./src/cardFilters/selectors/filters.js